<template>
  <aside></aside>
</template>

<script>
  export default {
    name: "base-product-sidebar-wrapper"
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/heartlandtan/src/vue-src/base/_base-product-sidebar-wrapper.vue